const Notifications = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#ABACD3" />
      <path
        d="M20 15.44V18.77"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.0199 11C16.3399 11 13.3599 13.98 13.3599 17.66V19.76C13.3599 20.44 13.0799 21.46 12.7299 22.04L11.4599 24.16C10.6799 25.47 11.2199 26.93 12.6599 27.41C17.4399 29 22.6099 29 27.3899 27.41C28.7399 26.96 29.3199 25.38 28.5899 24.16L27.3199 22.04C26.9699 21.46 26.6899 20.43 26.6899 19.76V17.66C26.6799 14 23.6799 11 20.0199 11Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M23.3299 27.82C23.3299 29.65 21.8299 31.15 19.9999 31.15C19.0899 31.15 18.2499 30.77 17.6499 30.17C17.0499 29.57 16.6699 28.73 16.6699 27.82"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <circle cx="26" cy="12" r="3" fill="#D92C2C" />
    </svg>
  );
};

export { Notifications };
